module.exports = __webpack_public_path__ + "img/logo.26dfbbb2.png";